
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"レイヤー 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Icon awesome-star","d":"M28.56 3.52l-7.81 15.84L3.27 21.9a3.83 3.83 0 00-2.11 6.54l12.66 12.32-3 17.39a3.83 3.83 0 005.55 4L32 54l15.63 8.22a3.84 3.84 0 005.17-1.63 3.77 3.77 0 00.38-2.4l-3-17.4 12.66-12.36a3.81 3.81 0 00.07-5.43 3.74 3.74 0 00-2.18-1.12l-17.5-2.54-7.81-15.82a3.83 3.83 0 00-6.86 0z"}})])
          )
        }
      }
    